import {
  Configuration,
  CreateConfigurationRequest,
  UpdateConfigurationRequest,
} from '../types';
import { BaseService } from './BaseService';

export class ConfigurationService extends BaseService<
  Configuration,
  CreateConfigurationRequest,
  UpdateConfigurationRequest
> {
  constructor() {
    super('/v1/configurations');
  }

  async getByCrew(crewId: number): Promise<Configuration[]> {
    const response = await this.getAll({ crew_id: crewId });
    return response.items;
  }

  async getByType(configType: string): Promise<Configuration[]> {
    const response = await this.getAll({ config_type: configType });
    return response.items;
  }

  async getActive(): Promise<Configuration[]> {
    const response = await this.getAll({ is_active: true });
    return response.items;
  }

  async getActiveByCrew(crewId: number): Promise<Configuration[]> {
    const response = await this.getAll({ crew_id: crewId, is_active: true });
    return response.items;
  }
}
